'use client'

import { Dialog, DialogPanel, TransitionChild } from '@headlessui/react'

import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop'
import { TopNavV6AccountPanelContent } from '@src/components/TopNavV6/TopNavV6AccountPanel/TopNavV6AccountPanelContent'
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context'
import { useHasMounted } from '@src/hooks/useHasMounted'
import { cn } from '@src/utils/tailwind'

export const TopNavV6AccountPanel = () => {
  const { isAccountExpanded, setAccountExpanded } = useTopNavV6()
  const hasMounted = useHasMounted()

  return (
    <Dialog
      transition
      open={isAccountExpanded && hasMounted}
      onClose={() => setAccountExpanded(false)}
      className="relative z-max transition duration-200 ease-out"
    >
      <ModalBackdrop className="hidden backdrop-blur-sm lg:block" />

      <div className="fixed inset-0 flex justify-end overflow-y-auto">
        <TransitionChild>
          <DialogPanel
            className={cn(
              'size-full max-w-full lg:w-[420px]',
              'duration-200 ease-out data-closed:translate-x-full'
            )}
          >
            <TopNavV6AccountPanelContent />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  )
}
